module.exports = __webpack_public_path__ + "static/media/Monaco.b8bb1f04.jpg";